import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { SvgIcon } from '../../common';
import { Accordion, Icon, Button } from 'semantic-ui-react';
import { replaceSpaceInName } from '../../../common/helperMethods';
import { connect } from 'react-redux';
import LoginButton from '../../common/LoginButton';
import GuestUserLoginToast from '../../common/GuestUserLoginAlert';

class Applications extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            visibleItems: 5,
            loading: false,
            showLoginAlert: false
        }
    }

    handleClick = (e, titleProps) => {
        const { index } = titleProps
        const { activeIndex } = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({ activeIndex: newIndex })
    }

    handleMoreClick = () => {
        const { auth, applications } = this.props;
        if (!auth) {
            this.ShowLogin(true);
        } else {
            this.setState({ loading: true });
            setTimeout(() => {
                this.setState({
                    visibleItems: applications.length,
                    loading: false
                })
            }, 1000);
        }
    }

    ShowLogin = (flag) => {
        if (flag == true) {
            this.setState({ showLoginAlert: true })
        }
    }

    setStateLoginClose = () => {
        this.setState({ showLoginAlert: false })
    }

    render() {
        const { activeIndex, visibleItems, loading } = this.state;
        const { applications, auth } = this.props;
        if (!applications) return null;

        const displayedItems = applications.slice(0, visibleItems);
        const hasMore = applications.length > visibleItems;

        return (
            <React.Fragment>
                <Accordion className="rawmaterial-list" styled fluid>
                    {
                        displayedItems && displayedItems.map((item, index) =>
                            <span key={item.application || index}>
                                <Accordion.Title
                                    active={activeIndex === index}
                                    index={index}
                                    onClick={this.handleClick}
                                >
                                    <div className="upper-row application-accordion-title-row">
                                        <div className="supplier-details">
                                            <Link to={`/product/${replaceSpaceInName(item.application_title)}/${item.application}`}>{item.application_title}</Link>
                                        </div>
                                        <div className="accordion-title-meta">
                                            {item.supplierCount > 0 && <span>{item.supplierCount} Suppliers</span>}
                                            <SvgIcon name="menu-arrow" viewbox="0 0 23.619 13.503" />
                                        </div>
                                    </div>
                                </Accordion.Title>
                                <Accordion.Content active={activeIndex === index}>
                                    <p>
                                        {item.description}
                                    </p>
                                </Accordion.Content>
                            </span>
                        )
                    }
                </Accordion>
                {
                    hasMore &&
                    <div className="text-center mt-2">
                        {auth ?
                            <Button className="color-light-blue w-100 text-center mt-2 cursor-pointer load_more" onClick={this.handleMoreClick} loading={loading}>
                                See All
                            </Button>
                            :
                            <LoginButton />
                        }
                    </div>
                }
                <GuestUserLoginToast {...this.props} show={this.state.showLoginAlert} setStateLoginClose={() => this.setStateLoginClose()} />
            </React.Fragment>
        )
    }
}

function mapStateToProps({ auth }) {
    return { auth };
}

export default connect(mapStateToProps)(Applications);